import React, { useEffect } from "react";
import { Switch, Route, Redirect, withRouter } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
import "./main.scss";
import TagManager from "react-gtm-module";
// import ReactGa from "react-ga";
import { Helmet } from "react-helmet";

//Navigation
import Header from "./Components/Navigation/Header/Header";
import Footer from "./Components/Navigation/Footer/Footer";

//Utils
import ScrollToTop from "./Components/Utils/ScrollToTop";

//Pages
import PageNotFound from "./Components/404";
import Home from "./Components/Pages/Home";
import Services from "./Components/Pages/Services/Main";
import ServicesPages from "./Components/Pages/Services/Featured";
import Styles from "./Components/Pages/Styles";
import FeaturedStyles from "./Components/Pages/Styles/Featured";
import About from "./Components/Pages/About";
import Team from "./Components/Pages/About/Team";
import Contact from "./Components/Pages/Contact";
import Reviews from "./Components/Pages/Reviews";
import Pagination from "./Components/Pages/Blog/Pagination/Pagination";
import BlogCategories from "./Components/Pages/Blog/Pagination/Categories";
import Blogs from "./Components/Pages/Blog/Blogs";
import Gallery from "./Components/Pages/Gallery";
import GalleryCategories from "./Components/Pages/Gallery/Categories";
import PrivacyPolicy from "./Components/Pages/Legals/PrivacyPolicy";
import Terms from "./Components/Pages/Legals/Terms";
import FAQs from "./Components/Pages/FAQs";
import ThankYou from "./Components/Pages/ThankYou";
import Careers from "./Components/Pages/Careers";
import Search from "./Components/Pages/Search";

// Turned Google Tag Manager back on because the search feature required a refresh.
// Google Analytics can be pulled from Google Tag Manager. That is why the Tag Manager code snippets on lines 9, 50, 53-59 have been turned off. -SN
const tagManagerArgs = {
  gtmId: "GTM-NSQB6MW",
};

TagManager.initialize(tagManagerArgs);

// ReactGa.initialize("UA-693200-1");

const App = ({ history }) => {
  // useEffect(() => {
  //   ReactGa.pageview(window.location.pathname + window.location.search);
  // }, []);

  // history.listen(() => {
  //   ReactGa.pageview(window.location.pathname + window.location.search);
  // });

  return (
    <>
      <ScrollToTop />
      <Header />
      <Helmet>
        <script
          type="text/javascript"
          src="//cdn.callrail.com/companies/960426926/934c9742824804533117/12/swap.js"
        ></script>
      </Helmet>
      <AnimatePresence exitBeforeEnter>
        <Switch>
          <Route exact component={Home} path="/" />
          <Route exact component={ThankYou} path="/thank-you-(org|ppc)" />
          <Route exact component={Services} path="/services" />
          <Route exact component={Careers} path="/careers" />
          <Route exact component={ServicesPages} path="/services/:category" />
          <Route exact component={Styles} path="/styles/:category" />
          <Route exact component={Gallery} path="/gallery/" />
          <Route
            exact
            component={GalleryCategories}
            path="/gallery/:category"
          />
          <Route
            exact
            component={FeaturedStyles}
            path="/styles/style/:category"
          />
          <Route exact component={Reviews} path="/reviews" />
          <Route exact component={Team} path="/about-us" />
          <Route exact component={About} path="/about-us/:category" />
          <Route exact component={Contact} path="/contact-us" />
          <Route exact component={Pagination} path="/blog/page/:page" />
          <Route
            exact
            component={BlogCategories}
            path="/blog/categories/:category/:page"
          />
          <Route exact component={Blogs} path="/blog/:title" />
          <Route exact component={PrivacyPolicy} path="/privacy-policy" />
          <Route exact component={Terms} path="/terms-and-conditions" />
          <Route exact component={FAQs} path="/faq" />
          <Route path="/search" component={Search} />
          <Route exact component={PageNotFound} path="*" />

          {/*Redirects*/}
          <Redirect from="/patios/" to="/blog/categories/patios/1" />
          <Redirect from="/pavers-download-guide/" to="/" />
          <Redirect from="/cdn-cgi/l/email-protection/" to="/" />
          <Redirect from="/tag/pool-deck-installation/" to="/blog/" />
          <Redirect
            from="/tag/concrete-pool-coping-in-los-angeles/"
            to="/blog/"
          />
          <Redirect from="/category/contractors/page/2/" to="/blog/" />
          <Redirect from="/category/blog/page/9/" to="/blog/" />
          <Redirect from="/category/paving-stones/page/7/" to="/blog/" />
          <Redirect from="/tag/walkway-pavers-in-california/" to="/blog/" />
          <Redirect from="/tag/interlocking-pavers-installation/" to="/blog/" />
          <Redirect from="/tag/installation/" to="/blog/" />
          <Redirect from="/tag/remodel/" to="/blog/" />
          <Redirect from="/tag/increase-home-value/" to="/blog/" />
          <Redirect from="/tag/paver-installation/" to="/blog/" />
          <Redirect from="/tag/earthquake-readiness/" to="/blog/" />
          <Redirect from="/tag/pavers/" to="/blog/" />
          <Redirect from="/tag/landscape-design/" to="/blog/" />
          <Redirect from="/tag/boulders/" to="/blog/" />
          <Redirect from="/tag/installing-retaining-walls/" to="/blog/" />
          <Redirect from="/tag/retaining-wall-uses/" to="/blog/" />
          <Redirect from="/tag/retaining-wall-designs/" to="/blog/" />
          <Redirect from="/tag/pathways/" to="/blog/" />
          <Redirect from="/tag/stepping-stones/" to="/blog/" />
          <Redirect from="/permeable-pavers/" to="/blog/" />
          <Redirect
            from="/choosing-a-paving-material/surviving-el-nino/"
            to="/blog/"
          />
          <Redirect from="/category/paving-stones/page/6/" to="/blog/" />
          <Redirect from="/tag/cost/" to="/blog/" />
          <Redirect from="/tag/brick/" to="/blog/" />
          <Redirect from="/tag/paving/" to="/blog/" />
          <Redirect from="/tag/driveway/" to="/blog/" />
          <Redirect from="/category/blog/page/7/" to="/blog/" />
          <Redirect from="/category/blog/page/8/" to="/blog/" />
          <Redirect from="/get-paving-stone-estimate-2/" to="/blog/" />
          <Redirect from="/tag/informal-walkway/" to="/blog/" />
          <Redirect from="/tag/walkway-design-ideas/" to="/blog/" />
          <Redirect from="/tag/paver-walkway/" to="/blog/" />
          <Redirect from="/tag/walkways/" to="/blog/" />
          <Redirect from="/tag/formal-walkway/" to="/blog/" />
          <Redirect from="/tag/patio-stones/" to="/blog/" />
          <Redirect from="/tag/patios-and-walkways/" to="/blog/" />
          <Redirect from="/tag/stone-patios/" to="/blog/" />
          <Redirect from="/tag/patio-designs/" to="/blog/" />
          <Redirect from="/driveways-download-guide/" to="/blog/" />
          <Redirect from="/tag/los-angeles/" to="/blog/" />
          <Redirect from="/tag/paving-stones/" to="/blog/" />
          <Redirect from="/tag/stamped-concrete/" to="/blog/" />
          <Redirect from="/tag/concrete/" to="/blog/" />
          <Redirect from="/services/patio-pavers/" to="/services/patios" />
          <Redirect
            from="/services/driveway-pavers/"
            to="/services/driveways"
          />
          <Redirect from="/pavers-installation-la/" to="/" />
          <Redirect
            from="/services/pool-deck-installation-california/"
            to="/services/pool-decks"
          />
          <Redirect from="/pavers/" to="/styles/variations" />
          <Redirect from="/pavers-installation-la/glendale/" to="/" />
          <Redirect
            from="/category/paving-stones/"
            to="/blog/categories/paving-stones/1"
          />
          <Redirect
            from="/pavers-installation-la/burbank/"
            to="/about-us/service-areas"
          />
          <Redirect
            from="/pavers-installation-la/south-pasadena/"
            to="/about-us/service-areas"
          />
          <Redirect
            from="/blog/navigating-yards-made-easy-stylish-paver-walkways/"
            to="/services/walkways"
          />
          <Redirect
            from="/blog/popular-paving-stones-2016-not-1996-anymore/"
            to="/blog/page/1"
          />
          <Redirect
            from="/blog/spruce-up-your-side-yard-this-summer-with-paving-stones/"
            to="/services/walkways"
          />
          <Redirect
            from="/pavers-installation-la/pasadena/"
            to="/about-us/service-areas"
          />
          <Redirect from="/35-paver-steps/" to="/services" />
          <Redirect from="/blog/paving-stones-vs-concrete/" to="/blog/page/1" />
          <Redirect
            from="/pavers-installation-la/agoura-hills/"
            to="/about-us/service-areas"
          />
          <Redirect
            from="/blog/hiring-guide-permeable-paving-projects-los-angeles-southern-california/"
            to="/blog/page/1"
          />
          <Redirect
            from="/pavers-installation-la/alhambra/"
            to="/about-us/service-areas"
          />
          <Redirect
            from="/category/permeable-pavers/"
            to="/blog/categories/permeable-pavers/1"
          />
          <Redirect
            from="/pavers-installation-la/altadena/"
            to="/about-us/service-areas"
          />
          <Redirect from="/the-installation-steps/" to="/services" />
          <Redirect
            from="/blog/enjoy-the-natural-beauty-of-stone-patios/"
            to="/services/patios"
          />
          <Redirect
            from="/blog/6-ways-to-use-pavers-in-your-home/"
            to="/services"
          />
          <Redirect
            from="/pavers-installation-la/sun-valley/"
            to="/about-us/financing"
          />
          <Redirect
            from="/pavers-installation-la/sherman-oaks/"
            to="/about-us/financing"
          />
          <Redirect
            from="/blog/pacific-pavingstone-recognized-by-inc-500-magazine-as-the-fastest-growing-privately-owned-interlocking-paving-stone-company-in-america/"
            to="/blog/page/1"
          />
          <Redirect
            from="/pool-deck/improve-the-value-of-an-outdoor-pool-with-deck-and-pool-coping/"
            to="/services/pool-decks"
          />
          <Redirect
            from="/blog/extend-quality-time-with-your-loved-ones-with-outdoor-fireplaces/"
            to="/blog/page/1"
          />
          <Redirect from="/blog/care-hardscape-winter/" to="/blog/page/1" />
          <Redirect
            from="/blog/water-wise-landscaping-pavers/"
            to="/services"
          />
          <Redirect
            from="/blog/choosing-the-right-paving-material/"
            to="/styles/style"
          />
          <Redirect from="/yelp-reviews/" to="/reviews" />
          <Redirect
            from="/blog/patios-for-the-season-spring/"
            to="/blog/page/1"
          />
          <Redirect
            from="/blog/outdoor-design-ideas-for-fall/"
            to="/blog/page/1"
          />
          <Redirect from="/showroom/" to="/contact-us" />
          <Redirect from="/blog/" to="/blog/page/1" />
          <Redirect
            from="/blog/pacific-outdoor-living-featured-on-nbcs-school-pride/"
            to="/blog/page/1"
          />
          <Redirect
            from="/blog/pasadena-showcase-house-of-design/"
            to="/blog/page/1"
          />
          <Redirect
            from="/wp-content/uploads/2020/05/5-red-flags.pdf/"
            to="/"
          />
          <Redirect from="/blog/what-is-stamped-concrete/" to="/blog/page/1" />
          <Redirect
            from="/contractors/using-paving-upgrade-california-home/"
            to="/"
          />
          <Redirect
            from="/blog/pacific-outdoor-living-won-2017-hna-awards/"
            to="/blog/page/1"
          />
          <Redirect
            from="/category/choosing-a-paving-material/"
            to="/blog/page/1"
          />
          <Redirect
            from="/blog/pacific-pavingstone-is-named-best-of-the-best/"
            to="/blog/page/1"
          />
          <Redirect
            from="/blog/saving-water-doesnt-have-to-be-hard-how-you-can-help/"
            to="/blog/page/1"
          />
          <Redirect from="/financing/" to="/about-us/financing" />
          <Redirect
            from="/pavers-installation-la/calabasas/"
            to="/about-us/service-areas"
          />
          <Redirect
            from="/blog/quality-driveway-paving/"
            to="/services/driveways"
          />
          <Redirect
            from="/blog/top-notch-driveway-paving/"
            to="/services/driveways"
          />
          <Redirect
            from="/category/driveways/page/2/"
            to="/blog/categories/driveways/1"
          />
          <Redirect
            from="/blog/ride-on-therapeutic-horsemanship/"
            to="/blog/page/1"
          />
          <Redirect
            from="/pavers-installation-la/beverly-hills/"
            to="/about-us/service-areas"
          />
          <Redirect from="/driveway-gallery/" to="/gallery/driveways" />
          <Redirect from="/category/patios/" to="/blog/categories/patios/1" />
          <Redirect
            from="/choosing-a-paving-material/categories-of-pavers-for-walkways-driveways-and-patio/"
            to="/styles/style"
          />
          <Redirect from="/blog/paving-stone-styles/" to="/styles/style" />
          <Redirect
            from="/category/contractors/"
            to="/blog/categories/contractors/1"
          />
          <Redirect
            from="/wp-content/uploads/2020/05/ppi-driveway-tipsheet.pdf/"
            to="/"
          />
          <Redirect from="/blog/5-patio-ideas-2018/" to="/blog/page/1" />
          <Redirect from="/our-crews/" to="/about-us" />
          <Redirect
            from="/category/retaining-walls/"
            to="/blog/categories/retaining-walls/1"
          />
          <Redirect
            from="/blog/nbc-school-pride-a-students-point-of-view/"
            to="/blog/page/1"
          />
          <Redirect from="/pool-decks-gallery/" to="/gallery/pool-decks" />
          <Redirect
            from="/category/installation/"
            to="/blog/categories/installation/1"
          />
          <Redirect from="/category/blog/" to="/blog/page/1" />
          <Redirect
            from="/blog/going-green-5-things-to-love-about-permeable-pavers/"
            to="/blog/know-your-paver-well-permeable-vs-concrete-pavers"
          />
          <Redirect from="/price-match-guarantee/" to="/about-us/financing" />
          <Redirect from="/patios-gallery/" to="/blog/categories/patios/1" />
          <Redirect from="/category/news/" to="/blog/page/1" />
          <Redirect
            from="/category/driveways/"
            to="/blog/categories/driveways/1"
          />
          <Redirect
            from="/paving-stone-education/"
            to="/blog/categories/paving-stones/1"
          />
          <Redirect from="/appointments/" to="/contact-us" />
          <Redirect from="/get-paving-stone-estimate/" to="/contact-us" />
          <Redirect from="/garden-walls-gallery/" to="/gallery/garden-walls" />
          <Redirect
            from="/blog/landscaping-with-patio-pavers/"
            to="/services/patios"
          />
          <Redirect
            from="/paving-stones/a-patio-is-better-for-you-than-a-deck-and-heres-why/"
            to="/blog/page/1"
          />
          <Redirect
            from="/blog/pacific-pavingstone-nbcs-school-pride/"
            to="/blog/page/1"
          />
          <Redirect
            from="/steps-coping-gallery/"
            to="/gallery/steps-and-coping"
          />
          <Redirect from="/walkways-gallery/" to="/gallery/walkways" />
          <Redirect
            from="/blog/pacific-pavingstone-2004-inc-500-list/"
            to="/blog/page/1"
          />
          <Redirect from="/blog/surviving-el-nino/" to="/blog/page/1" />
          <Redirect
            from="/blog/permeable-pavers/"
            to="/blog/know-your-paver-well-permeable-vs-concrete-pavers"
          />
          <Redirect from="/press-awards/" to="/" />
          <Redirect
            from="/blog/how-to-design-a-pool-deck/"
            to="/services/pool-decks"
          />
          <Redirect
            from="/blog/nbc-school-pride-update-7210/"
            to="/blog/page/1"
          />
          <Redirect from="/category/nbc-school-pride-2/" to="/blog/page/1" />
          <Redirect from="/category/pool-deck/" to="/blog/page/1" />
          <Redirect from="/blog/hna-hardscape-award/" to="/blog/page/1" />
          <Redirect
            from="/blog/outdoor-living-with-paving-stones/"
            to="/blog/page/1"
          />
          <Redirect from="/appointments/online/" to="/contact-us" />
          <Redirect from="/pavers-and-pricing/" to="/about-us/financing" />
          <Redirect
            from="/paving-stones/why-you-should-hire-professionals-for-interlocking-pavers-installation/"
            to="/"
          />
          <Redirect
            from="/category/patios/page/2/"
            to="/blog/categories/patios/1"
          />
          <Redirect from="/blog/school-pride-update-63010/" to="/" />
          <Redirect
            from="/blog/retaining-walls-with-a-natural-look/"
            to="/blog/constructing-hillside-retaining-walls-los-angeles-every-homeowner-needs-know/"
          />
          <Redirect
            from="/blog/patio-pavers-can-transform-your-home/"
            to="/services/patios"
          />
          <Redirect from="/category/blog/page/5/" to="/blog/page/1" />
          <Redirect from="/pavers-guide-2/" to="/" />
          <Redirect
            from="/blog/paving-stones-with-a-natural-look/"
            to="/blog/page/1"
          />
          <Redirect from="/category/blog/page/4/" to="/blog/page/1" />
          <Redirect from="/category/blog/page/6/" to="/blog/page/1" />
          <Redirect
            from="/category/patios/page/3/"
            to="/blog/categories/patios/1"
          />
          <Redirect
            from="/category/paving-stones/page/2/"
            to="/blog/categories/paving-stones/1"
          />
          <Redirect
            from="/blog/adding-value-to-your-home-with-paving-stones-for-driveways/"
            to="/services/driveways"
          />
          <Redirect
            from="/category/walkways-2/"
            to="/blog/categories/walkways/1"
          />
          <Redirect from="/category/equestrian/" to="/blog/page/1" />
          <Redirect
            from="/category/choosing-a-paving-material/page/2/"
            to="/blog/categories/choosing-a-paving-material/1"
          />
          <Redirect
            from="/wp-content/uploads/2020/05/ppi-patios-tipsheet.pdf/"
            to="/"
          />
          <Redirect
            from="/category/paving-stones/page/3/"
            to="/blog/categories/paving-stones/1"
          />
          <Redirect from="/los-angeles-paving-customers/" to="/" />
          <Redirect
            from="/blog/choosing-the-right-contractor/"
            to="/blog/page/1"
          />
          <Redirect from="/fireplaces-gallery/" to="/blog/page/1" />
          <Redirect from="/category/blog/page/2/" to="/blog/page/1" />
          <Redirect from="/paving-stone-customer-service/" to="/contact-us" />
          <Redirect from="/category/personal/" to="/blog/page/1" />
          <Redirect from="/category/blog/page/3/" to="/blog/page/1" />
          <Redirect from="/blog/rainwater-harvesting/" to="/blog/page/1" />
          <Redirect
            from="/category/paving-stones/page/4/"
            to="/blog/categories/paving-stones/1"
          />
          <Redirect
            from="/category/paving-stones/page/5/"
            to="/blog/categories/paving-stones/1"
          />
          <Redirect
            from="/category/walkways-2/page/2/"
            to="/blog/categories/walkways/1"
          />
          <Redirect from="/patios-download-guide/" to="/services/patios" />
          <Redirect from="/blog/how-to-stain-a-deck/" to="/blog/page/1" />
          <Redirect
            from="/paving-stones/practical-solutions-ideas-paver-patio-walkway-steps/"
            to="/blog/page/1"
          />
          <Redirect
            from="/choosing-a-paving-material/porcelain-travertine-pavers-2-great-alternatives-los-angeles-patio-pool-deck-walkway/"
            to="/blog/page/1"
          />
          <Redirect
            from="/blog/the-interlocking-system-how-does-it-work-for-pavers/"
            to="/blog/page/1"
          />
          <Redirect
            from="/blog/backyard-paver-patio-design-ideas/"
            to="/blog/page/1"
          />
          <Redirect
            from="/retaining-walls/landscape-lighting-around-patio-walkway-driveway-will-transform-los-angeles-property/"
            to="/blog/page/1"
          />
          <Redirect from="/blog/what-is-flagstone/" to="/blog/page/1" />
          <Redirect from="/blog/what-are-grass-pavers/" to="/blog/page/1" />
          <Redirect
            from="/the-history-of-the-interlocking-paver/"
            to="/blog/page/1"
          />
          <Redirect
            from="/patios/facts-and-tips-when-planting-trees-near-a-patio-in-southern-california/"
            to="/blog/page/1"
          />
          <Redirect
            from="/blog/find-driveway-paving-contractor/"
            to="/blog/page/1"
          />
          <Redirect
            from="/blog/interlocking-pavers-versus-concrete/"
            to="/blog/page/1"
          />
          <Redirect
            from="/blog/tumbled-pavers-get-the-look-and-feel-of-an-old-stone-road/"
            to="/blog/page/1"
          />
          <Redirect
            from="/blog/how-to-replace-a-paving-stone/"
            to="/blog/page/1"
          />
          <Redirect
            from="/blog/choosing-best-paving-materials-los-angeles-pool-patio/"
            to="/blog/page/1"
          />
          <Redirect
            from="/blog/dont-make-costly-mistake-hiring-paving-contractor/"
            to="/blog/page/1"
          />
          <Redirect
            from="/blog/how-to-choose-paver-design-for-your-home/"
            to="/blog/page/1"
          />
          <Redirect
            from="/blog/increasing-home-value-pavers/"
            to="/blog/page/1"
          />
          <Redirect
            from="/blog/7-myths-about-pavers-debunked/"
            to="/blog/page/1"
          />
          <Redirect from="/blog/how-to-clean-your-patio/" to="/blog/page/1" />
          <Redirect
            from="/blog/restore-paving-stone-beauty-quick-tips-to-get-rid-of-weeds/"
            to="/blog/page/1"
          />
          <Redirect
            from="/blog/using-rocks-boulders-for-your-landscape/"
            to="/blog/page/1"
          />
          <Redirect
            from="/blog/dont-make-costly-mistake-hiring-paving-contractor/"
            to="/blog/page/1"
          />
          <Redirect
            from="/blog/tips-on-hiring-patio-paver-installers/"
            to="/blog/page/1"
          />
          <Redirect
            from="/personal/5-patio-ideas-2018/"
            to="/services/patios"
          />
          <Redirect
            from="/driveways/3-driveway-ideas-youll-love/"
            to="/services/driveways"
          />
          <Redirect
            from="/blog/the-benefits-of-stones-for-driveway-paving/"
            to="/services/driveways"
          />
          <Redirect
            from="/blog/install-stepping-stones-pathway/"
            to="/services/steps-and-coping"
          />
          <Redirect
            from="/blog/long-term-benefits-of-choosing-paving-stone-steps/"
            to="/services/steps-and-coping"
          />
          <Redirect
            from="/blog/retaining-wall-uses-and-benefits/"
            to="/constructing-hillside-retaining-walls-los-angeles-every-homeowner-needs-know/"
          />
          <Redirect
            from="/blog/retaining-wall-design-ideas/"
            to="/constructing-hillside-retaining-walls-los-angeles-every-homeowner-needs-know/"
          />
          <Redirect from="/pricing/" to="/about-us/financing" />
          <Redirect
            from="/pricing/angelus-antique-stone/"
            to="/about-us/financing"
          />
          <Redirect
            from="/pricing/angelus-courtyard-stone/"
            to="/about-us/financing"
          />
          <Redirect
            from="/pricing/angelus-estate-cobble/"
            to="/about-us/financing"
          />
          <Redirect
            from="/pricing/angelus-heartland-paver/"
            to="/about-us/financing"
          />
          <Redirect from="/pricing/angelus-holland/" to="/about-us/financing" />
          <Redirect from="/pricing/angelus-paseo/" to="/about-us/financing" />
          <Redirect
            from="/pricing/angelus-pavilion/"
            to="/about-us/financing"
          />
          <Redirect
            from="/pricing/angelus-slatestone/"
            to="/about-us/financing"
          />
          <Redirect from="/pricing/angelus-slaton/" to="/about-us/financing" />
          <Redirect
            from="/pricing/?SingleProduct=162/"
            to="/about-us/financing"
          />
          <Redirect
            from="/pricing/artistic-atlantic/"
            to="/about-us/financing"
          />
          <Redirect
            from="/pricing/artistic-corallock/"
            to="/about-us/financing"
          />
          <Redirect from="/pricing/artistic-desert/" to="/about-us/financing" />
          <Redirect
            from="/pricing/artistic-stonelock/"
            to="/about-us/financing"
          />
          <Redirect
            from="/pricing/artistic-tumblelock/"
            to="/about-us/financing"
          />
          <Redirect
            from="/pricing/belgard-bergerac/"
            to="/about-us/financing"
          />
          <Redirect
            from="/pricing/belgard-cambridge-cobble/"
            to="/about-us/financing"
          />
          <Redirect
            from="/pricing/belgard-catalina-grana/"
            to="/about-us/financing"
          />
          <Redirect from="/pricing/belgard-dublin/" to="/about-us/financing" />
          <Redirect from="/pricing/belgard-holland/" to="/about-us/financing" />
          <Redirect from="/pricing/belgard-lafitt/" to="/about-us/financing" />
          <Redirect
            from="/pricing/belgard-mega-arbel/"
            to="/about-us/financing"
          />
          <Redirect
            from="/pricing/belgard-moduline/"
            to="/about-us/financing"
          />
          <Redirect
            from="/pricing/belgard-old-world-paver/"
            to="/about-us/financing"
          />
          <Redirect from="/pricing/belgard-slate/" to="/about-us/financing" />
          <Redirect
            from="/pricing/belgard-subterra/"
            to="/about-us/financing"
          />
          <Redirect from="/pricing/belgard-urbana/" to="/about-us/financing" />
          <Redirect from="/prices/" to="/about-us/financing" />
        </Switch>
      </AnimatePresence>
      <Footer />
    </>
  );
};

export default withRouter(App);
